import _ from 'ckLodash';
import rangeUtils from 'utils/rangeUtils';
import utils from 'utils/utils';

/**
 * @param sourceElem {CKEDITOR.dom.element}
 * @param destElem {CKEDITOR.dom.element}
 * @param {Function} [predicateFunc] optional filter function
 */
function cloneStylesToElement(sourceElem, destElem, predicateFunc) {
    var sourceStyles = sourceElem.$.style;
    _.chain(sourceStyles)
        .filter(predicateFunc)
        .forEach(function (styleName) {
            destElem.setStyle(styleName, sourceStyles[styleName]);
        }).value();
}

//todo: remove editor from function signature
function getWalkerForElement(editor, element) {
    var range = new CKEDITOR.dom.range(element);
    range.selectNodeContents(element);
    return new CKEDITOR.dom.walker(range);
}

/**
 * @param sourceElem {CKEDITOR.dom.element}
 * @param destElem {CKEDITOR.dom.element}
 * @param {Function} [predicateFunc] optional filter function
 */
function cloneClassesToElement(sourceElem, destElem, predicateFunc) {
    var classList = sourceElem.$.classList;
    _.chain(classList)
        .filter(predicateFunc)
        .forEach(function (classToApply) {
            destElem.addClass(classToApply);
        }).value();
}

function isWhiteSpace(elem) {
    return utils.isWhiteSpace(elem.getText());
}

function isElementTextEmpty(element) {
    //ignore our or ck's invisible temporary guards
    return element && utils.removeGuardsChars(element.$.textContent).length === 0;
}

function getTextBeforeCursor(range, element) {
    if (!range.startPath().contains(element)) {
        return null;
    }
    //todo - please choose meaningful name
    var r = range.clone();
    r.setStart(element, 0);
    //todo wrong logic. should set end to current start
    r.setEnd(r.endContainer, r.endOffset);
    return rangeUtils.getText(r);
}

function getElementFromPath(elementsPath, tagName) {
    return _.find(elementsPath.elements, function (element) {
        return _.result(element, 'getName') === tagName;
    });
}

function removeClassesWithPrefix(element, prefix) {
    if (!element.$) {
        return;
    }

    _.chain(element.$.classList)
        .filter(function (existingClass) {
            return _.startsWith(existingClass, prefix);
        })
        .forEach(function (existingClass) {
            element.removeClass(existingClass);
        })
        .value();
}

function replaceElementByItsContents(element) {
    var elementHtml = element.getHtml();
    var cleanedHtmlContent = utils.removeGuardsChars(elementHtml);
    var frag = utils.getCKDocumentFragment(cleanedHtmlContent);
    frag.replace(element);
}

function getTheme(element) {
    return _.find(element.getAttribute('class').split(' '), (cssClass) => _.startsWith(cssClass, 'font_'));
}

export default {
    cloneStylesToElement: cloneStylesToElement,
    cloneClassesToElement: cloneClassesToElement,
    getElementFromPath: getElementFromPath,
    getTextBeforeCursor: getTextBeforeCursor,
    getWalkerForElement: getWalkerForElement,
    isElementTextEmpty: isElementTextEmpty,
    isWhiteSpace: isWhiteSpace,
    removeClassesWithPrefix: removeClassesWithPrefix,
    replaceElementByItsContents: replaceElementByItsContents,
    getTheme: getTheme
};
